import { Link } from "@tanstack/react-router"
import { SquareUser } from "lucide-react"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  SidebarSeparator,
} from "@holigral/shared/ui/components/ui/sidebar"
import { useIsRouteActive, useLocale } from "@holigral/shared/routing"
import AdminNav from "./AdminNav"
import TenantSelect from "./TenantSelect"
import TenantNav from "./TenantNav"
import { Logo } from "@/ui"
import FooterMenu from "@/app/sidebar/FooterMenu"
import { useEffectiveTenantSlug } from "@/tenant"
import { useT } from "@/i18n"

export default function AppSidebar() {
  const { t } = useT()
  const tenantSlug = useEffectiveTenantSlug()
  const locale = useLocale()
  // Admin mode (product.md §9.1): own nav; the workspace switcher stays but
  // reads "Admin" (selecting a workspace is how you leave).
  const isAdminArea = useIsRouteActive({ to: "/admin", fuzzy: true })
  const isMyProfilesActive = useIsRouteActive({
    to: "/myprofiles",
    fuzzy: true,
  })

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              className="px-0 group-data-[collapsible=icon]:px-0!"
              render={
                <Link to="/$locale" params={{ locale }}>
                  <Logo
                    size={18}
                    variant="full"
                    className="group-data-[state=collapsed]:hidden"
                  />
                  <Logo
                    size={18}
                    variant="glyph"
                    className="group-data-[state=expanded]:hidden"
                  />
                </Link>
              }
            />
          </SidebarMenuItem>
        </SidebarMenu>
        <SidebarSeparator className="ml-0" />
        {/* My Profiles pinned at the very top, above the workspace switcher
            and separated from the per-workspace nav — it is personal and
            cross-workspace, not scoped to any tenant (product.md §10.2). */}
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              isActive={isMyProfilesActive}
              render={
                <Link to="/myprofiles">
                  <SquareUser />
                  {t("nav.myProfiles")}
                </Link>
              }
            />
          </SidebarMenuItem>
        </SidebarMenu>
        {(isAdminArea || tenantSlug) && (
          <>
            <SidebarSeparator className="ml-0" />
            <TenantSelect />
            <SidebarSeparator className="ml-0" />
          </>
        )}
      </SidebarHeader>
      <SidebarContent>
        {isAdminArea ? (
          <SidebarGroup>
            <AdminNav />
          </SidebarGroup>
        ) : (
          tenantSlug && (
            <SidebarGroup>
              <TenantNav tenantSlug={tenantSlug} />
            </SidebarGroup>
          )
        )}
      </SidebarContent>
      <SidebarFooter>
        <FooterMenu />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
